export default "__VITE_ASSET__DUvBUCXD__"